import { render, staticRenderFns } from "./CommonComp.vue?vue&type=template&id=1b146596&scoped=true&"
import script from "./CommonComp.vue?vue&type=script&lang=js&"
export * from "./CommonComp.vue?vue&type=script&lang=js&"
import style0 from "./CommonComp.vue?vue&type=style&index=0&id=1b146596&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b146596",
  null
  
)

export default component.exports